module.exports = __webpack_public_path__ + "static/img/wjCode1.a160a1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xyd/index/wjCode1.png
// module id = hf2J
// module chunks = 86